import { render, staticRenderFns } from "./WeatherStationFishery.vue?vue&type=template&id=f30b2b96&scoped=true&"
import script from "./WeatherStationFishery.vue?vue&type=script&lang=js&"
export * from "./WeatherStationFishery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30b2b96",
  null
  
)

export default component.exports